<template>
  <div class="notify-list" @click="openNotice">
    <el-tooltip content="通知中心" placement="bottom" effect="light" popper-class="tooltip-import">
      <el-badge is-dot :hidden="unreadNotifyCount <= 0" class="item">
        <i class="iconfont icon-tongzhi1"></i>
      </el-badge>
    </el-tooltip>
  </div>
  <!--  <el-popover v-model="visible" placement="top" popper-class="notify-list">-->
  <!--    &lt;!&ndash; 需要区分旧版 新版通知 新版是chatAccountId&ndash;&gt;-->
  <!--    <div v-for="(item, index) in commentNotifyList" :key="index">-->
  <!--      <div v-if="index <= 9" class="item" :class="index == 0 ? 'first' : ''" @click="commentNotifyRead(item)">-->
  <!--        <span class="opa">"{{ item.commentNickName }}"{{ item.commentType == 1 ? "点赞" : "评论" }}了你的朋友圈</span>-->
  <!--        <br />-->
  <!--        <span class="time">{{ item.chatAccountId ? formatTime(item.commentTime) : item.commentTime }}</span>-->
  <!--      </div>-->
  <!--    </div>-->

  <!--    <div v-if="commentNotifyList.length == 0" class="notify">暂无通知</div>-->

  <!--    <div slot="reference" class="msg">-->
  <!--      <div v-if="commentNotifyList.length > 0" class="badge"><el-badge :value="commentNotifyList.length" class="item"></el-badge></div>-->
  <!--      <i class="iconfont icon-xiaoxi"></i>-->
  <!--    </div>-->
  <!--  </el-popover>-->
</template>
<script>
import { mapMutations, mapState } from "vuex"
import { apiCommentNotifyReadNew } from "@/api/voyager/moments"
import { apiCommentNotifyRead } from "@/api/wx-chat/comment"
import dayjs from "dayjs"
export default {
  name: "Index",
  data() {
    return {
      visible: false
    }
  },
  computed: {
    ...mapState("comment", ["commentNotifyList"]),
    ...mapState("user", ["unreadNotifyCount"])
  },
  mounted() {
    // 获取是否有未读
    this.getUnreadCount()
  },
  methods: {
    ...mapMutations("comment", ["GET_COMMENT_NOTIFY_LIST", "RESET_PAGE"]),
    openNotice() {
      // 打开列表
      this.$notifyPage.show()
    },
    commentNotifyRead(item) {
      this.visible = false
      if (item.chatAccountId) {
        const chatAccountIdList = this.commentNotifyList.map(item => item.chatAccountId).filter(chatAccountId => chatAccountId !== undefined)
        apiCommentNotifyReadNew({
          chatAccountIds: [...new Set(chatAccountIdList)]
        }).then(res => {
          this.RESET_PAGE(true)
          this.GET_COMMENT_NOTIFY_LIST([])
          this.$router.push({ path: "/voyager#/voyager/wechatMoments/commentMoments" })
        })
      } else {
        const wxUins = this.commentNotifyList.map(item => item.wxUin).filter(wxUin => wxUin !== undefined)
        apiCommentNotifyRead({
          uinList: [...new Set(wxUins)]
        }).then(res => {
          this.RESET_PAGE(true)
          this.GET_COMMENT_NOTIFY_LIST([])
          this.$router.push({ path: "/userData#/userData/wechatMoments/commentMoments" })
        })
      }
    },
    formatTime(val) {
      return dayjs(val).format("YYYY-MM-DD HH:mm:ss")
    },
    getUnreadCount() {
      // 获取是否有未读
      this.$store.dispatch("user/getUnreadNotifyCount")
    }
  }
}
</script>

<style scoped lang="scss">
.msg {
  color: #999;
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .badge {
    position: absolute;
    right: 3px;
    top: -5px;
  }

  .icon-xiaoxi {
    margin: 0 auto;
    color: #ffffff;
  }
}
</style>
<style>
.notify-list {
  text-align: center;
  cursor: pointer;
}
</style>
